declare global {
  interface Window {
    env: any;
  }
}

export interface IAuth0Env {
  audience: string;
  clientId: string;
  domain: string;
}

export interface IEnv {
  apiBaseUrl: string;
  auth0: IAuth0Env;
  s3Host: string;
}

const w = typeof window !== 'undefined' ? window.env : undefined;

export const env: IEnv = {
  apiBaseUrl: w?.REACT_APP_API_BASE_URL ?? process.env.EXPO_PUBLIC_API_BASE_URL!,
  auth0: {
    audience: w?.REACT_APP_AUTH0_AUDIENCE ?? process.env.EXPO_PUBLIC_AUTH0_AUDIENCE!,
    clientId: w?.REACT_APP_AUTH0_CLIENT_ID ?? process.env.EXPO_PUBLIC_AUTH0_CLIENT_ID!,
    domain: w?.REACT_APP_AUTH0_DOMAIN ?? process.env.EXPO_PUBLIC_AUTH0_DOMAIN!,
  },
  s3Host: w?.REACT_APP_S3_HOST ?? process.env.EXPO_PUBLIC_S3_HOST!,
}